import React from 'react';
import { Compass, Target } from 'lucide-react';
import { motion } from 'framer-motion';

const VisionMission = () => {
  return (
    <section id="vision-mission" className="scroll-mt-24 bg-lotus-petal/30 px-6 pb-20 lg:px-8 lg:py-28">
      <div className="mx-auto max-w-7xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.7 }}
          className="mx-auto max-w-3xl text-center mb-14 lg:mb-20"
        >
          <span className="mb-4 inline-block rounded-full bg-white/80 px-4 py-1 text-xs font-semibold uppercase tracking-[0.3em] text-lotus-deep shadow-sm">
            Vision & Our Mission
          </span>
          <h2 className="font-serif text-3xl leading-tight text-lotus-ink sm:text-4xl lg:text-5xl">
            Guiding Purpose & Core Intentions
          </h2>
        </motion.div>

        <div className="grid gap-8 md:grid-cols-2 lg:gap-12 mt-12">
          {/* Vision Card */}
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.7, delay: 0.1 }}
            whileHover={{ y: -6 }}
            className="flex flex-col justify-between rounded-3xl bg-white p-8 sm:p-12 shadow-sm border border-lotus-petal/80 transition-all duration-300 hover:shadow-xl hover:border-lotus-deep/40"
          >
            <div>
              <div className="flex items-center gap-3 mb-6">
                <div className="flex items-center justify-center size-10 rounded-2xl bg-lotus-petal/50 text-lotus-deep">
                  <Compass size={22} />
                </div>
                <span className="text-xs font-medium uppercase tracking-[0.3em] text-lotus-deep">
                  Vision
                </span>
              </div>
              
              <h3 className="font-serif text-2xl leading-snug text-lotus-ink sm:text-3xl">
                A world where mental well-being is embraced as an essential part of everyday life
              </h3>
              
              <p className="mt-6 text-base leading-relaxed text-lotus-ink/70 sm:text-lg">
                We aspire to empower individuals and organizations to thrive with greater balance, resilience, and purpose. When people are mentally, emotionally, physically, and energetically well, they unlock their highest potential.
              </p>
            </div>
          </motion.div>

          {/* Mission Card */}
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.7, delay: 0.25 }}
            whileHover={{ y: -6 }}
            className="flex flex-col justify-between rounded-3xl bg-white p-8 sm:p-12 shadow-sm border border-lotus-petal/80 transition-all duration-300 hover:shadow-xl hover:border-lotus-deep/40"
          >
            <div>
              <div className="flex items-center gap-3 mb-6">
                <div className="flex items-center justify-center size-10 rounded-2xl bg-lotus-petal/50 text-lotus-deep">
                  <Target size={22} />
                </div>
                <span className="text-xs font-medium uppercase tracking-[0.3em] text-lotus-deep">
                  Our Mission
                </span>
              </div>

              <h3 className="font-serif text-2xl leading-snug text-lotus-ink sm:text-3xl">
                Creating spaces where people feel supported, valued, and empowered
              </h3>

              <p className="mt-6 text-base leading-relaxed text-lotus-ink/70 sm:text-lg">
                At Lotus Prana, every healing session, meditation, and wellness initiative is delivered with compassion, professionalism, and a deep respect for each individual's journey. Our greatest measure of success is the positive impact we create in people's lives.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;
